"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getMailboxCalendarConfigurationOperation_1 = require("owa-service/lib/operation/getMailboxCalendarConfigurationOperation");
function getMailboxCalendarConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMailboxCalendarConfigurationOperation_1.default()];
                case 1:
                    response = _a.sent();
                    if (response.ErrorCode) {
                        return [2 /*return*/, null];
                    }
                    else {
                        return [2 /*return*/, response.Options];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = getMailboxCalendarConfiguration;
//# sourceMappingURL=getMailboxCalendarConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/services/getMailboxCalendarConfiguration.js
// module id = 5249
// module chunks = 2